import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, of, take } from 'rxjs';
import { EntOfficeListItemJSON } from '../common/models/server-response/ent-office-list-item-json.model';
import { EntOfficeListItem } from '../common/models/users-data/ent-office-list-item.model';
import { RequestsService } from './requests.service';
import { CountryId } from 'src/common-panel/constants/country-configs.constants';

@Injectable({
  providedIn: 'root'
})
export class EntOfficeService {
  entOfficeList: EntOfficeListItem[] = []


  constructor(private requestsService: RequestsService) { }

  loadEntOfficeListByCountry(country: CountryId): BehaviorSubject<boolean>
  {
    let l_loaded = new BehaviorSubject<boolean>(false)
    this.requestsService.loadEntOfficeListByCountry(country).pipe(
      take(1),
      catchError(err => { return of([]) })
    ).subscribe(l_entOfficeList =>
    {
      let l_data: EntOfficeListItem[] = []

      l_entOfficeList.forEach(l_entOffice =>
      {
        let l_checkedEntOffice = this.checkEntOfficeData(l_entOffice)
        if (l_checkedEntOffice)
        {
          l_data.push(l_checkedEntOffice)
        }

      })
      this.entOfficeList = l_data
      l_loaded.next(true)
    })
    return l_loaded
  }
  
  checkEntOfficeData(entOfficeListItem: EntOfficeListItemJSON): EntOfficeListItem | null
  {

    if (!entOfficeListItem.entOfficeId)
    {
      console.error(`Error: EntOffice ${ JSON.stringify(entOfficeListItem) } hasn't ID.`)

      return null;
    }


    let l_entOfficeListItem: EntOfficeListItem = {
      city: entOfficeListItem.city,
      entOfficeName: entOfficeListItem.entOfficeName ? entOfficeListItem.entOfficeName : '',
      addressLine1: entOfficeListItem.addressLine1 ? entOfficeListItem.addressLine1 : '',
      addressLine2: entOfficeListItem.addressLine2 ? entOfficeListItem.addressLine2 : '',
      entOfficeId: entOfficeListItem.entOfficeId
    }
    return l_entOfficeListItem;
  }

  clearEntOfficeList()
  {
    this.entOfficeList = []
  }
}
